<template>
  <BreadCrumb PageTitle="Phosphoricons" />
  <PhosphoriconsContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import PhosphoriconsContent from "../../template-components/Icons/Phosphoricons/PhosphoriconsContent.vue";

export default defineComponent({
  name: "PhosphoriconsPage",
  components: {
    BreadCrumb,
    PhosphoriconsContent,
  },
});
</script>